import {
  Action,
  combineReducers,
  configureStore,
  createAction
} from '@reduxjs/toolkit';

import buyerReducer from './buyer/buyer.slice';
import cashierReducer from './casher/casher.slice';
import commerceReducer from './commerce/commerce.slice';
import imageUrlReducer from './imageUrl/imageUrl.slice';
import transactionReducer from './transaction/transaction.slice';
import userReducer from './user/user.slice';

export const rootReducer = (state: any, action: Action<string>) => {
  if (action.type === 'RESET_STATE') {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

const appReducer = combineReducers({
  buyer: buyerReducer,
  commerce: commerceReducer,
  transaction: transactionReducer,
  user: userReducer,
  cashier: cashierReducer,
  imageUrl: imageUrlReducer
});

export const store = configureStore({
  reducer: rootReducer,
  devTools: true
});

export const restoreReduxState = createAction('RESET_STATE');

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
